import { useSelectedProductVariant } from '@/features/pos/components/ProductConfigurationModal/hooks/useSelectedProductVariant'
import AddonGroup from '@/features/pos/components/ProductConfigurationModal/parts/AddonGroup'
import RemovableIngredientGroup from '@/features/pos/components/ProductConfigurationModal/parts/RemovableIngredientGroup'
import VariantGroup from '@/features/pos/components/ProductConfigurationModal/parts/VariantGroup'
import { ProductVariant } from '@/features/pos/components/ProductConfigurationModal/types'
import { isMultiVariantProduct } from '@/features/pos/components/ProductConfigurationModal/utils/isMultiVariantProduct'
import React, { FC } from 'react'
import { ScrollView } from 'react-native-gesture-handler'

interface ConfigurationsProps {
    productVariants: ProductVariant[]
}

const Configurations: FC<ConfigurationsProps> = ({ productVariants }) => {
    const productVariant = useSelectedProductVariant(productVariants)

    return (
        <ScrollView
            showsVerticalScrollIndicator={false}
            contentContainerStyle={{ paddingHorizontal: 16, paddingBottom: 24, gap: 24 }}
        >
            {isMultiVariantProduct(productVariants) && (
                <VariantGroup productVariants={productVariants} />
            )}
            {productVariant?.addonGroups.map((addonGroup) => (
                <AddonGroup key={addonGroup.id} addonGroup={addonGroup} />
            ))}
            {!!productVariant?.removableIngredients.length && (
                <RemovableIngredientGroup ingredients={productVariant.removableIngredients} />
            )}
        </ScrollView>
    )
}

export default Configurations
